import { map } from 'ramda';

import { BusinessSectorType } from 'store/modules/assistant/assistant';
import { getLabelByIntlPrefix } from 'components/IntlProvider';

export const businessSectorsToSelect = (
  results: BusinessSectorType[],
  locale: string
) =>
  map(
    (sector: BusinessSectorType) => ({
      label: getLabelByIntlPrefix(sector, locale, 'en_sector'),
      value: sector.id.toString(),
    }),
    results || []
  );

export const businessSectorsToApi = (
  selectedSectors: { label: string; value: string }[]
): number[] =>
  map(
    ({ value }: { value: string }) => parseInt(value, 10),
    selectedSectors || []
  );
